import React from 'react'
import { useTranslation } from "react-i18next";
import { catalogTableLabel } from "../../app/helpers/helperCatalogs";

const ViewTextGenericCatalog = ({ values, values2, field, moduleText, occupation = 6, css_class }) => {
    const { t } = useTranslation();   

    return (
       <div className={`col-md-${occupation} ${css_class} viewContentGroup`}>
            <label htmlFor={field} className="tit-view-view tit-content-view-view">
                {t(`${moduleText}.synthetic.${field}`)}
            </label>
            <div
                className="txt-view viewContentTxt"
                name={field}
                id={field}
            >{catalogTableLabel(values[values2])}</div>
        </div>
    )
}

export default ViewTextGenericCatalog